function omit(obj, omittedKeys) {
  const ret = {};
  const omitted = new Set(omittedKeys);
  for (const key in obj) {
    if (!obj.hasOwnProperty(key)) continue;
    if (omitted.has(key)) continue;
    ret[key] = obj[key];
  }
  return ret;
}
export default {
  fromServer: data => ({
    uid: data.uid,
    email: data.email,
    firstName: data.first_name,
    lastName: data.last_name,
    company: data.company,
    title: data.title,
    language: data.language,
    removed: data.removed,
    role: (data.role && data.role.uid) || null,
    photoUrl: data.photo_url,
    photoThumbnailUrl: data.photo_thumbnail_url,
  }),
  toServer: data =>
    Object.assign({}, omit(data, ["firstName", "lastName"]), {
      first_name: data.firstName,
      last_name: data.lastName,
    }),
};
